import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import './UploadInfoModal.css';

function UploadInfoModal({ isOpen, onClose, upload }) {
  const [isClosing, setIsClosing] = useState(false);
  if (!isOpen || !upload) return null;

  const renderList = (arr) =>
    Array.isArray(arr)
      ? (
          <ul className="UIM-list">
            {arr.map((f, i) => (
              <li key={i}>
                {typeof f === 'object' ? `${f.gb} GB (${f.rawBytes} bytes)` : f}
              </li>
            ))}
          </ul>
        )
      : arr;

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      setIsClosing(false);
      onClose();
    }, 300);
  };

  const formatDate = (d) => (d ? new Date(d).toLocaleString() : '');

  return (
    <div className={`UIM-modal-overlay${isClosing ? ' closing' : ''}`} onClick={handleClose}>
      <div className={`UIM-modal ${isClosing ? 'closing' : ''}`} onClick={(e) => e.stopPropagation()}>
        <div className="UIM-header">
          <h2>Upload Details</h2>
          <button className="UIM-close-button" onClick={handleClose}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>
        <div className="UIM-content">
          <table className="UIM-table">
            <tbody>
              <tr><td>ID</td><td>{upload.id}</td></tr>
              <tr><td>Patient</td><td>{upload.patientId}</td></tr>
              <tr><td>Analysis</td><td>{upload.analysisCode}</td></tr>
              <tr><td>Sample</td><td>{upload.sampleCode}</td></tr>
              <tr><td>Project</td><td>{upload.projectId}</td></tr>
              <tr><td>Visit</td><td>{upload.visitNumber}</td></tr>
              <tr><td>Original Files</td><td>{renderList(upload.originalFileNames)}</td></tr>
              <tr><td>New Files</td><td>{renderList(upload.newFileName)}</td></tr>
              <tr><td>Status</td><td>{upload.status}</td></tr>
              <tr><td>Upload Time</td><td>{formatDate(upload.upload_time)}</td></tr>
              <tr><td>Initiated</td><td>{formatDate(upload.initiated_time)}</td></tr>
              <tr><td>Completed</td><td>{formatDate(upload.completed_time)}</td></tr>
              <tr><td>File Size</td><td>{renderList(upload.fileSize)}</td></tr>
              <tr><td>Details</td><td>{upload.details}</td></tr>
              <tr><td>Result Code</td><td>{upload.resultCode}</td></tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default UploadInfoModal;
